<template>
	<v-layout justify-center align-center :style="{ height: `${$vuetify.breakpoint.height - 18}px` }">
		<v-flex xl3 lg4 md5 sm6 xs12 class="text-center">
			<v-img
				src="@/assets/logo.png"
				max-width="150"
				class="mx-auto"
				transition="scale-transition"
			/>
			<p class="text-uppercase font-weight-bold text-h6 my-4 primary--text">
				Edunix transport
			</p>

			<v-form ref="form" @submit.prevent="login" :disabled="loading">
				<v-card rounded="xl">
					<v-card-title class="primary--text">
						<v-spacer/>
						{{$t('routes.login')}}
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-row class="ma-0">
							<!-- center -->
							<v-col v-if="userMultiCenter" cols="12" class="py-0">
								<v-autocomplete
									v-model.number="centerId"
									:label="$t('inputs.center')"
									:items="centers"
									item-text="Name"
									item-value="Id"
									dense
									outlined
									:rules="rules.requiredAsNumber"
									:loading="loadingCenters"
								/>
							</v-col>

							<!-- username -->
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="username"
									:label="$t('inputs.username')"
									dense
									outlined
									:rules="rules.required"
								/>
							</v-col>

							<!-- password -->
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="password"
									:label="$t('inputs.password')"
									:type="showPassword ? 'text' : 'password'"
									dense
									outlined
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									@click:append="showPassword = !showPassword"
									:rules="rules.required"
								/>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="pt-0">
						<v-spacer/>
						<v-btn
							type="submit"
							color="primary"
							:loading="loading"
						>
							{{$t('login')}}
						</v-btn>
						<v-spacer/>
					</v-card-actions>
				</v-card>
			</v-form>
			
			<p class="text-caption mt-4">
				powered by
				<a
					target="_blank"
					href="https://www.beetronix.com"
					class="text-decoration-none"
				>
					BEETRONIX
				</a>
			</p>
		</v-flex>
	</v-layout>
</template>

<script>
import { userMultiCenter } from '@/configs/general.configs'
import { mapState } from 'vuex'
import rules from '@/helpers/validation rules'

export default {
	name: 'Login',

	data: () => ({
		rules,
		userMultiCenter,

		showPassword: false,
		loading: false,
		loadingCenters: false,

		// submit data
		centerId: null,
		username: null,
		password: null,
	}),

	computed: {
		...mapState({
			centers: state => state.centers.centers
		})
	},

	methods: {
		login() {
			if (this.$refs.form.validate()) {
				this.loading = true;
				this.$store.dispatch('auth/login', {
					centerId: userMultiCenter ? this.centerId : 0,
					username: this.username,
					password: this.password
				}).then(() => {
					this.$router.replace({ name: 'home' });
					this.$store.dispatch('companyInfo/fetchAll');
				}).finally(() => {
					this.loading = false;
				})
			}
		}
	},

	created() {
		if (userMultiCenter && !this.centers.length) {
			this.loadingCenters = true;
			this.$store.dispatch('centers/fetchAll').finally(c => {
				this.loadingCenters = false;
			})
		}
	}
}
</script>

<style>

</style>